<app-referral-match-verifications-ehr-listing
  [loading]="loadingReferralMatchOptions"
  [editable]="editable"
  [patientPrescriber]="patientPrescriber"
  [prescriber]="capture.prescriber"
  [referralMatchOptions]="referralMatchOptions"
  (newEhrReferralVerification)="onNewEhrReferralVerification($event)"
  (ehrReferralVerificationEdited)="onEhrReferralVerificationEdited($event)"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
